import { useContext } from 'react';

import { Button } from '@/common/styleguide/atoms/Button/Button';
import { ComingSoonDrawerContext } from '@/modules/HomePage/components/ComingSoon/ComingSoonDrawer/ComingSoonDrawerContext';
import CurrentEvents from '@/modules/HomePage/components/CurrentEvents/CurrentEvents';
import FeaturedEvent from '@/modules/HomePage/components/FeaturedEvent/FeaturedEvent';

import styles from './whatsNew.module.scss';

const WhatsNew = (): JSX.Element => {
  const { handleOpenDrawer } = useContext(ComingSoonDrawerContext);

  return (
    <section className={styles.container} data-testid="whats-new">
      <div className={styles.headingWrapper}>
        <span className={styles.dot} />
        <h2 className={styles.heading} data-testid="whats-new-heading">
          What&apos;s new
        </h2>
        <Button className={styles.seeAll} onClick={handleOpenDrawer} variant="text">
          See upcoming
        </Button>
      </div>

      <div className={styles.events}>
        <FeaturedEvent />
        <CurrentEvents />
      </div>
    </section>
  );
};

export default WhatsNew;
